import { Controller } from "@hotwired/stimulus"
import { LOCATION_KEY, clearDenial, isDeniedLocally } from "../field_location"

// Connects to data-controller="field-geolocation"
// Mounted on body, so Turbo Drive reconnects it on every navigation.
//
// Card #4833 -- this used to call getCurrentPosition on every connect()
// (every page load and Turbo navigation), ~86 requests/tasker/day in
// production. It no longer requests a fix itself at all: location is now
// only ever requested at the specific moments field_location.js's header
// comment lists (map/places "Nearest", response submission, shift
// start/end, an online sync pass). This controller's only remaining job is
// passive: watch the Permissions API so a denial recorded by any of those
// moments self-heals the instant the Tasker fixes it in their phone's
// Settings, without waiting for them to come back to this app's own
// Settings page and tap "Enable location" (field_settings_controller.js's
// requestLocation() is the other way a denial clears).
export default class extends Controller {
  connect() {
    this._watchPermission()
  }

  disconnect() {
    if (this._permissionStatus) this._permissionStatus.onchange = null
  }

  _watchPermission() {
    if (!("permissions" in navigator)) return
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      this._permissionStatus = result
      this._maybeClearDenial(result.state)
      result.onchange = () => this._maybeClearDenial(result.state)
    }).catch(() => {})
  }

  _maybeClearDenial(state) {
    if (state === "granted" && isDeniedLocally()) clearDenial()
  }

  static getUserLocation() {
    try { return JSON.parse(localStorage.getItem(LOCATION_KEY)) }
    catch { return null }
  }
}
